import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @Input() label = 'Upload Document';
  @Input() accept = '.jpg,.jpeg,.png';
  @Input() multiple = false;
  @Output() fileSelected = new EventEmitter<File>();
  @Input() required = false;
  fileName = '';
  fileInput: any;
  uploadProgress = 0;
  fileSize: string;
  isSubmitted = false;
  constructor(private http: HttpClient) {}
  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];
    this.fileSelected.emit(file);
    this.fileName = file.name;
    this.fileSize = this.formatBytes(file.size);
    this.uploadProgress = 100;
  }
  
  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    this.http.post('YOUR_API_URL', formData, {
      reportProgress: true,
      observe: 'events',
    }).subscribe((event: HttpEvent<any>) => {

      if (event.type === HttpEventType.UploadProgress && event.total) {
        this.uploadProgress = Math.round(
          (event.loaded / event.total) * 100
        );
      }

      if (event.type === HttpEventType.Response) {
        this.uploadProgress = 100;
      }
    });
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 KB';
    return Math.round(bytes / 1024) + ' KB';
  }

  validate(): boolean {
    this.isSubmitted = true;
    return !this.required || !!this.fileName;
  }
}
